import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { pole } from '../utils';
import { getTokenPayload, jeDispecerTechnik } from '../auth';
import { VYSLEDEK_LABEL, CEKA_DUVODY } from '../tiketyConst';
import VyberCesty from './VyberCesty';
import { DateTimeInput } from './DateInput';
import {
  inputStyle, selectStyle, labelStyle, btnPrimary, btnOutline, card, chyboveHlaseni, apiChyba,
  naLocalInput, zLocalInput, formatMin, moznostiMin, formatDatCas, prazskyDen,
} from '../ui';

const API = process.env.REACT_APP_API_URL || '/api';
const DELKY_KONZULTACE = [5, 10, ...moznostiMin(15, 480, 15)];
const CAS_NA_MISTE = moznostiMin(30, 720, 30);
const DOBA_CESTY = moznostiMin(15, 720, 15);

function Radio({ hodnota, vybrano, onChange, popisek }) {
  const aktivni = vybrano === hodnota;
  return (
    <label style={{
      display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', marginBottom: '8px', cursor: 'pointer',
      border: `2px solid ${aktivni ? '#3ab54a' : '#d1d5db'}`, borderRadius: '8px', background: aktivni ? '#f0fdf4' : '#fff', fontSize: '16px',
    }}>
      <input type="radio" checked={aktivni} onChange={() => onChange(hodnota)} style={{ width: '20px', height: '20px' }} />
      {popisek}
    </label>
  );
}

// Aktivitu eviduje technik, proto ji nejde zapsat u tiketu bez řešitele (backend vrací 422).
// Dispečer/admin tu řešitele rovnou přiřadí, technik si tiket vezme sám.
function BezResitele({ tiket, ja, onPrirazeno, onZrusit }) {
  const technik = getTokenPayload()?.role === 'technik';
  const dispecerTechnik = jeDispecerTechnik();   // přiřadí komukoli, nebo si tiket vezme sám
  const [resitele, setResitele] = useState([]);
  const [id, setId] = useState('');
  const [chyba, setChyba] = useState(null);
  useEffect(() => { if (!technik) axios.get(`${API}/resitele`).then(r => setResitele(pole(r.data))).catch(() => {}); }, [technik]);
  const vzitSi = async () => {
    try { await axios.post(`${API}/tikety/${tiket.id}/priradit`, { resitel_id: ja?.uid }); onPrirazeno(); }
    catch (e) { setChyba(apiChyba(e)); }
  };
  const priradit = async () => {
    const resitelId = technik ? ja?.uid : Number(id);
    if (!resitelId) { setChyba('Vyberte řešitele.'); return; }
    try { await axios.post(`${API}/tikety/${tiket.id}/priradit`, { resitel_id: resitelId }); onPrirazeno(); }
    catch (e) { setChyba(apiChyba(e)); }
  };
  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Přidat aktivitu</h3>
      <div style={chyboveHlaseni}>{technik ? 'Nejdřív si tiket převezměte.' : 'Nejdřív přiřaďte řešitele (technika).'}</div>
      {!technik && (
        <select style={selectStyle} value={id} onChange={e => setId(e.target.value)}>
          <option value="">— vyberte řešitele —</option>
          {resitele.map(r => <option key={r.id} value={r.id}>{r.jmeno}</option>)}
        </select>
      )}
      {chyba && <div style={chyboveHlaseni}>{chyba}</div>}
      <button style={{ ...btnPrimary, width: '100%', marginTop: '12px' }} onClick={priradit}>{technik ? 'Vzít si tiket' : 'Přiřadit řešitele'}</button>
      {dispecerTechnik && <button style={{ ...btnPrimary, width: '100%', marginTop: '8px' }} onClick={vzitSi}>Vzít si tiket</button>}
      <button style={{ ...btnOutline, width: '100%', marginTop: '8px' }} onClick={onZrusit}>Zpět</button>
    </div>
  );
}

// Formulář aktivity: Telefonická konzultace / Výjezd. Výsledek jako povinná radio tlačítka.
export default function PridatAktivitu({ tiket, onHotovo, onZrusit, onPrirazeno }) {
  const ja = getTokenPayload();
  const [typ, setTyp] = useState(tiket.bude_vyjezd ? 'vyjezd' : 'konzultace');
  const [vysledek, setVysledek] = useState('');
  const [cekaDuvod, setCekaDuvod] = useState('');
  const [resitele, setResitele] = useState([]);
  const [pracoviste, setPracoviste] = useState([]);
  const [vychoziPracoviste, setVychoziPracoviste] = useState('');
  // konzultace
  const [datumCas, setDatumCas] = useState(naLocalInput());
  const [delka, setDelka] = useState(15);
  const [sKym, setSKym] = useState('');
  const [popisReseni, setPopisReseni] = useState('');
  const [cenaText, setCenaText] = useState('');
  // výjezd
  const [prijezd, setPrijezd] = useState(naLocalInput());
  const [naMiste, setNaMiste] = useState(30);
  const [reseni, setReseni] = useState('');
  const [zbozi, setZbozi] = useState([]);
  const [dalsiTechnik, setDalsiTechnik] = useState('');
  const [cestaOtevrena, setCestaOtevrena] = useState(false);
  const [pracovisteId, setPracovisteId] = useState('');
  const [dobaCesty, setDobaCesty] = useState('');
  const [odkazTiket, setOdkazTiket] = useState('');
  const [poznamka, setPoznamka] = useState('');
  // stav
  const [chyba, setChyba] = useState(null);
  const [ukladam, setUkladam] = useState(false);

  useEffect(() => {
    axios.get(`${API}/resitele`).then(r => setResitele(pole(r.data).filter(x => x.id !== tiket.resitel?.id))).catch(() => {});
    axios.get(`${API}/pracoviste`).then(r => setPracoviste(pole(r.data))).catch(() => {});
    axios.get(`${API}/technici`).then(r => {
      const me = pole(r.data).find(x => x.id === tiket.resitel?.id);
      if (me?.vychozi_pracoviste_id) { setVychoziPracoviste(String(me.vychozi_pracoviste_id)); setPracovisteId(String(me.vychozi_pracoviste_id)); }
    }).catch(() => {});
    // eslint-disable-next-line
  }, []);

  // Náhled ceny konzultace; pravidlo počítá backend (stejně jako při uložení).
  useEffect(() => {
    if (typ !== 'konzultace' || !vysledek) { setCenaText(''); return undefined; }
    let platne = true;
    axios.get(`${API}/konzultace-cena`, { params: { zakaznik_id: tiket.zakaznik_id, delka_min: Number(delka), vysledek } })
      .then(r => { if (platne) setCenaText(r.data.cena_text || ''); })
      .catch(() => { if (platne) setCenaText(''); });
    return () => { platne = false; };
  }, [typ, vysledek, delka, tiket.zakaznik_id]);

  const vlozZbozi = () => setZbozi(z => [...z, { polozka: '', mnozstvi: 1 }]);
  const zmenZbozi = (i, k, v) => setZbozi(z => z.map((r, j) => (j === i ? { ...r, [k]: v } : r)));

  const spolecne = () => {
    if (!vysledek) return 'Vyberte výsledek aktivity.';
    if (vysledek === 'cekame' && !cekaDuvod) return 'Vyberte důvod čekání.';
    return null;
  };

  const sestav = () => {
    const telo = { typ, vysledek, ceka_duvod: vysledek === 'cekame' ? cekaDuvod : null };
    if (typ === 'konzultace') {
      Object.assign(telo, { datum_cas: zLocalInput(datumCas), delka_min: Number(delka), s_kym: sKym.trim() || null, popis_reseni: popisReseni.trim() });
    } else {
      Object.assign(telo, {
        prijezd_at: zLocalInput(prijezd), cas_na_miste_min: Number(naMiste), reseni: reseni.trim(),
        zbozi: zbozi.filter(z => z.polozka.trim()).map(z => ({ polozka: z.polozka.trim(), mnozstvi: Number(String(z.mnozstvi).replace(',', '.')) || 1 })),
        dalsi_technik_id: dalsiTechnik ? Number(dalsiTechnik) : null,
      });
      if (odkazTiket) {
        Object.assign(telo, { doba_cesty_min: 0, cesta_zapoctena_u_tiketu_id: Number(odkazTiket), poznamka: poznamka.trim() || null });
      } else if (dobaCesty !== '') {
        Object.assign(telo, { doba_cesty_min: Number(dobaCesty), pracoviste_id: pracovisteId ? Number(pracovisteId) : null, poznamka: poznamka.trim() || null });
      }
    }
    return telo;
  };

  // naNahled: výjezd se uloží bez podpisu a rodič hned otevře náhled protokolu k podpisu na místě
  const odeslat = async (naNahled = false) => {
    setChyba(null);
    setUkladam(true);
    try {
      const r = await axios.post(`${API}/tikety/${tiket.id}/aktivity`, sestav());
      onHotovo(naNahled ? r.data : null);
    } catch (e) { setChyba(apiChyba(e)); setUkladam(false); }
  };

  const overVyplneni = () => {
    const spol = spolecne();
    if (spol) return spol;
    if (typ === 'konzultace' && !popisReseni.trim()) return 'Vyplňte popis řešení.';
    if (typ === 'vyjezd') {
      if (!reseni.trim()) return 'Vyplňte provedené řešení.';
      if (!odkazTiket && dobaCesty !== '' && !pracovisteId) return 'Vyberte pracoviště, odkud se jelo.';
    }
    return null;
  };

  const ulozit = (naNahled) => { const c = overVyplneni(); if (c) { setChyba(c); return; } odeslat(naNahled); };
  const ulozitBezPodpisu = () => ulozit(false);
  const ulozitAPodepsat = () => ulozit(true);

  if (!tiket.resitel) return <BezResitele tiket={tiket} ja={ja} onPrirazeno={onPrirazeno} onZrusit={onZrusit} />;

  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Přidat aktivitu</h3>
      {ja?.uid !== tiket.resitel.id && (
        <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '8px', padding: '10px 12px', marginBottom: '12px', fontSize: '15px' }}>
          Zapisuji za: <strong>{tiket.resitel.jmeno}</strong>
        </div>
      )}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
        {[['konzultace', '📞 Telefonická konzultace'], ['vyjezd', '🚗 Výjezd']].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setTyp(k)} style={{ ...(typ === k ? btnPrimary : btnOutline), flex: 1, fontSize: '15px' }}>{l}</button>
        ))}
      </div>

      {typ === 'konzultace' ? (
        <div style={card}>
          <label style={labelStyle}>Datum a čas hovoru</label>
          <DateTimeInput value={datumCas} onChange={setDatumCas} />
          <label style={labelStyle}>Délka hovoru</label>
          <select style={selectStyle} value={delka} onChange={e => setDelka(e.target.value)}>
            {DELKY_KONZULTACE.map(m => <option key={m} value={m}>{formatMin(m)}</option>)}
          </select>
          <label style={labelStyle}>S kým (nepovinné)</label>
          <input style={inputStyle} value={sKym} onChange={e => setSKym(e.target.value)} />
          <label style={labelStyle}>Popis řešení *</label>
          <textarea style={{ ...inputStyle, minHeight: '100px' }} value={popisReseni} onChange={e => setPopisReseni(e.target.value)} />
        </div>
      ) : (
        <>
          <div style={card}>
            <strong>Na prodejně</strong>
            <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '6px' }}>Požadavek přijat: <strong style={{ color: '#111827' }}>{formatDatCas(tiket.prijato_at)}</strong></div>
            <label style={labelStyle}>Příjezd na prodejnu</label>
            <DateTimeInput value={prijezd} onChange={setPrijezd} />
            <label style={labelStyle}>Čas na místě (každá započatá půlhodina)</label>
            <select style={selectStyle} value={naMiste} onChange={e => setNaMiste(e.target.value)}>
              {CAS_NA_MISTE.map(m => <option key={m} value={m}>{formatMin(m)}</option>)}
            </select>
            <label style={labelStyle}>Popis problému (z tiketu)</label>
            <div style={{ ...inputStyle, background: '#f3f4f6', whiteSpace: 'pre-wrap', minHeight: '40px' }}>{tiket.popis_problemu}</div>
            <label style={labelStyle}>Provedené řešení *</label>
            <textarea style={{ ...inputStyle, minHeight: '90px' }} value={reseni} onChange={e => setReseni(e.target.value)} />

            <label style={labelStyle}>Použité zboží</label>
            {zbozi.map((z, i) => (
              <div key={i} style={{ display: 'flex', gap: '6px', marginBottom: '6px' }}>
                <input style={{ ...inputStyle, flex: 1 }} placeholder="Položka" value={z.polozka} onChange={e => zmenZbozi(i, 'polozka', e.target.value)} />
                <input style={{ ...inputStyle, width: '76px' }} inputMode="decimal" value={z.mnozstvi} onChange={e => zmenZbozi(i, 'mnozstvi', e.target.value)} />
                <button type="button" style={{ ...btnOutline, padding: '0 14px' }} onClick={() => setZbozi(zb => zb.filter((_, j) => j !== i))} aria-label="Odebrat">×</button>
              </div>
            ))}
            <button type="button" style={btnOutline} onClick={vlozZbozi}>+ Přidat položku</button>

            <label style={labelStyle}>Další technik (nepovinné)</label>
            <select style={selectStyle} value={dalsiTechnik} onChange={e => setDalsiTechnik(e.target.value)}>
              <option value="">— žádný —</option>
              {resitele.map(r => <option key={r.id} value={r.id}>{r.jmeno}</option>)}
            </select>
          </div>

          <div style={card}>
            <button type="button" onClick={() => setCestaOtevrena(o => !o)} style={{ ...btnOutline, width: '100%', textAlign: 'left' }}>
              {cestaOtevrena ? '▼' : '▶'} Doplnit později (cesta)
              {!cestaOtevrena && dobaCesty !== '' && ` – ${formatMin(Number(dobaCesty))}`}
            </button>
            {cestaOtevrena && (
              <div>
                <p style={{ fontSize: '13px', color: '#6b7280' }}>Bez cestovní části zůstane výjezd označen jako „Nedoplněno“ – doplníte ho později doma.</p>
                <label style={labelStyle}>Cesta započtena u jiného výjezdu ze stejného dne (pak se u tohoto tiketu zapíše 0 min)</label>
                <VyberCesty datum={prazskyDen(prijezd)} technikId={tiket.resitel.id} kromeTiketId={tiket.id} value={odkazTiket} onChange={setOdkazTiket} />
                {!odkazTiket && (
                  <>
                    <label style={labelStyle}>Pracoviště (odkud se vyjíždělo)</label>
                    <select style={selectStyle} value={pracovisteId} onChange={e => setPracovisteId(e.target.value)}>
                      <option value="">— vyberte —</option>
                      {pracoviste.map(p => <option key={p.id} value={p.id}>{p.nazev}{String(p.id) === vychoziPracoviste ? ' (výchozí)' : ''}</option>)}
                    </select>
                    <label style={labelStyle}>Celková doba cesty (z pracoviště a zpět, celá trasa)</label>
                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>Při více zastávkách v jednom dni zadejte celkový čas celé trasy u jednoho tiketu a u ostatních zvolte ‚Cesta započtena u jiného výjezdu‘.</div>
                    <select style={selectStyle} value={dobaCesty} onChange={e => setDobaCesty(e.target.value)}>
                      <option value="">— doplním později —</option>
                      {DOBA_CESTY.map(m => <option key={m} value={m}>{formatMin(m)}</option>)}
                    </select>
                  </>
                )}
                <label style={labelStyle}>Poznámka</label>
                <input style={inputStyle} value={poznamka} onChange={e => setPoznamka(e.target.value)} />
              </div>
            )}
          </div>
        </>
      )}

      <div style={card}>
        <strong>Výsledek *</strong>
        <div style={{ marginTop: '8px' }}>
          {Object.entries(VYSLEDEK_LABEL).map(([k, l]) => <Radio key={k} hodnota={k} vybrano={vysledek} onChange={setVysledek} popisek={l} />)}
        </div>
        {typ === 'konzultace' && cenaText && (
          <div style={{ marginTop: '4px', fontSize: '14px' }}>Cena konzultace: <strong>{cenaText}</strong></div>
        )}
        {vysledek === 'cekame' && (
          <>
            <label style={labelStyle}>Důvod čekání *</label>
            <select style={selectStyle} value={cekaDuvod} onChange={e => setCekaDuvod(e.target.value)}>
              <option value="">— vyberte důvod —</option>
              {CEKA_DUVODY.map(d => <option key={d} value={d}>{d}</option>)}
            </select>
          </>
        )}
      </div>

      {chyba && <div style={chyboveHlaseni}>{chyba}</div>}

      {typ === 'konzultace' ? (
        <button style={{ ...btnPrimary, width: '100%' }} onClick={ulozitBezPodpisu} disabled={ukladam}>{ukladam ? 'Ukládám…' : 'Uložit'}</button>
      ) : (
        <>
          <button style={{ ...btnPrimary, width: '100%' }} onClick={ulozitAPodepsat} disabled={ukladam}>{ukladam ? 'Ukládám…' : '✍️ Uložit a podepsat na místě'}</button>
          <button style={{ ...btnOutline, width: '100%', marginTop: '8px' }} onClick={ulozitBezPodpisu} disabled={ukladam}>{ukladam ? 'Ukládám…' : 'Uložit bez podpisu (podepíše se později)'}</button>
        </>
      )}
      <button style={{ ...btnOutline, width: '100%', marginTop: '8px', border: 'none', color: '#6b7280' }} onClick={onZrusit} disabled={ukladam}>Zrušit</button>
    </div>
  );
}
